@import url('../../../styles/component.css');

* {
    /* reset */
    margin: 0px;
}

:host {
    border-radius: 8px;
    padding: 2.5rem 2rem;

    background: no-repeat bottom 0px center / 100% url("data:image/svg+xml,%3Csvg width='336' height='391' viewBox='0 0 336 391' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.54'%3E%3Crect x='42.75' y='264.25' width='136.492' height='88.8297' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3Ccircle cx='52.5663' cy='272.213' r='2.5' fill='url(%23paint0_linear_263_5)'/%3E%3Ccircle cx='52.5663' cy='272.213' r='2.25' stroke='white' stroke-opacity='0.8' stroke-width='0.5'/%3E%3Cline x1='135.504' y1='272.501' x2='149.879' y2='272.501' stroke='white' stroke-width='0.5'/%3E%3Cline x1='157.128' y1='272.501' x2='171.105' y2='272.501' stroke='white' stroke-width='0.5'/%3E%3Crect x='51.3163' y='281.265' width='120.097' height='59.8755' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3Cline y1='-0.25' x2='134.866' y2='-0.25' transform='matrix(0.894199 0.44767 -0.708987 0.705222 51.0663 281.015)' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3Cline y1='-0.25' x2='134.866' y2='-0.25' transform='matrix(0.894199 -0.44767 0.708987 0.705222 51.0663 341.39)' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3C/g%3E%3Cg opacity='0.5'%3E%3Cpath d='M245.854 261.248H276.135' stroke='%230F40E1'/%3E%3Cline x1='245.848' y1='257.078' x2='260.995' y2='257.078' stroke='%2379AFE1' stroke-width='1.5'/%3E%3Cline x1='245.854' y1='264.87' x2='272.662' y2='264.87' stroke='%230F40E1'/%3E%3Crect x='223' y='255.37' width='18.1237' height='11.2537' fill='url(%23paint1_linear_263_5)'/%3E%3Crect x='223.25' y='255.62' width='17.6237' height='10.7537' stroke='%23FFFEFE' stroke-opacity='0.5' stroke-width='0.5'/%3E%3Cpath d='M245.854 241.248H276.135' stroke='%230F40E1'/%3E%3Cline x1='245.848' y1='237.078' x2='260.995' y2='237.078' stroke='%2379AFE1' stroke-width='1.5'/%3E%3Cline x1='245.854' y1='244.87' x2='272.662' y2='244.87' stroke='%230F40E1'/%3E%3Crect x='223' y='235.37' width='18.1237' height='11.2537' fill='url(%23paint2_linear_263_5)'/%3E%3Crect x='223.25' y='235.62' width='17.6237' height='10.7537' stroke='%23FFFEFE' stroke-opacity='0.5' stroke-width='0.5'/%3E%3Cpath d='M245.854 279.248H276.135' stroke='%230F40E1'/%3E%3Cline x1='245.848' y1='275.078' x2='260.995' y2='275.078' stroke='%2379AFE1' stroke-width='1.5'/%3E%3Cline x1='245.854' y1='282.87' x2='272.662' y2='282.87' stroke='%230F40E1'/%3E%3Crect x='223' y='273.37' width='18.1237' height='11.2537' fill='url(%23paint3_linear_263_5)'/%3E%3Crect x='223.25' y='273.62' width='17.6237' height='10.7537' stroke='%23FFFEFE' stroke-opacity='0.5' stroke-width='0.5'/%3E%3C/g%3E%3Cg opacity='0.5'%3E%3Crect x='156.128' y='36' width='110' height='75' fill='url(%23paint4_linear_263_5)'/%3E%3Crect x='156.378' y='36.25' width='109.5' height='74.5' stroke='%23FFFEFE' stroke-opacity='0.5' stroke-width='0.5'/%3E%3C/g%3E%3Cg opacity='0.5'%3E%3Crect x='199.93' y='82.25' width='109.5' height='74.5' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3Cline y1='-0.25' x2='133.135' y2='-0.25' transform='matrix(0.826227 0.563337 -0.593901 0.804538 199.68 82)' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3Cline y1='-0.25' x2='133.135' y2='-0.25' transform='matrix(0.826227 -0.563337 0.593901 0.804538 199.68 157)' stroke='white' stroke-opacity='0.65' stroke-width='0.5'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_263_5' x1='51.9699' y1='269.726' x2='51.9343' y2='274.726' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233F5FF2'/%3E%3Cstop offset='1' stop-color='%235FAEFD'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_263_5' x1='223' y1='260.997' x2='240.971' y2='264.178' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233F5FF2'/%3E%3Cstop offset='1' stop-color='%235FAEFD'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_263_5' x1='223' y1='240.997' x2='240.971' y2='244.178' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233F5FF2'/%3E%3Cstop offset='1' stop-color='%235FAEFD'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_263_5' x1='223' y1='278.997' x2='240.971' y2='282.178' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233F5FF2'/%3E%3Cstop offset='1' stop-color='%235FAEFD'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear_263_5' x1='156.128' y1='73.5' x2='265.767' y2='91.1775' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233F5FF2'/%3E%3Cstop offset='1' stop-color='%235FAEFD'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A"),
        var(--surface--dark--linear-gradient);

    display: inline-block;
    color: var(--color--light-text);
    font-size: 1.3rem;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    max-width: 320px;
    flex-shrink: 0;

    align-self: flex-start;
}

cta-button a,
cta-button a:visited {
    color: inherit;
    text-decoration: none;
}

link-button {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
}

link-button::before {
    content: "";
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: .6rem;
    background-color: var(--surface--color--primary--light);
    margin-left: -2px;
    margin-right: 4px;

}

section {
    display: flex;
    flex-direction: column;
}

h2 {

    max-width: 60%;
    font-size: 2.5rem;
    font-weight: 500;
    margin: 1.3rem 0;
}

h2,
p {

    text-shadow: 0px 2px 2px rgba(116, 116, 116, 0.25);
}

p {
    margin-bottom: 3rem;
}

cta-button {
    margin: .65rem 0;
}

a {
    color: inherit;
    text-decoration: none;
}

a:visited {
    color: inherit;
}